import { useCallback, useState } from 'react';

const STORAGE_KEY = 'lens-askrichard-sidebar';

function storedOpen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'closed';
  } catch {
    return true;
  }
}

export function useLensSidebarOpen(narrow: boolean): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => !narrow && storedOpen());
  const update = useCallback(
    (next: boolean) => {
      setOpen(next);
      if (narrow) {
        return;
      }
      try {
        localStorage.setItem(STORAGE_KEY, next ? 'open' : 'closed');
      } catch {
        return;
      }
    },
    [narrow],
  );
  return [open, update];
}
